import React, { useEffect, useState } from 'react';
import AdminMenu from '../Admin';
import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import { useNavigate, useParams } from 'react-router-dom';
import EditSkillPathComponent from '../../components/admin/EditSkillPathComponent';
import { useGetSkillPathData } from '../../hooks/useSkillPathData';
import { ISkillPath } from '../../model/SkillPath.model';
import { useGetSkillLevelsOData } from '../../hooks/useSkillLevelData';
import { protectedResources } from '../../authConfig';
import Loading from '../../components/Loading/Loading';

const EditSkillPath = () => {

    const {id, parentid} = useParams();
    const [skillPath, setSkillPath] = useState<ISkillPath | null>(null);

    const [loadingSP, setLoadingSP] = useState(true);
    var triggerRefresh = false;
    //const [skillLevels, loadingSL, slErr1, slErr2] = useGetSkillLevelsOData(`$filter=SkillPathid eq '${id}'&$orderby=indexNumber`);
    //console.log('sl', skillLevels);
    /*const [idM, setIdM] = useState(id);

      // This callback will run whenever the dependencies
      // specified in the second argument change.
      useEffect(() => {
        if (idM!==id) {
          setIdM(id);
          setSkillPath(null);
          console.log('updating idm', id);
        }
      }, [id])*/ // <= the dependencies
    const [err1, err2] = useGetSkillPathData(id as string, skillPath, setSkillPath, loadingSP, setLoadingSP);

if (skillPath && (skillPath as any).skillPathId && id && (skillPath as any).skillPathId!=id) {
  setSkillPath(null);
  triggerRefresh = true;
}
    const { error, execute } = useFetchWithMsal({
        scopes: protectedResources.apiCFSkillPath.scopes.read,
      });
      const [loading, setLoading] = useState(true);
      const [callErr, setErr] = useState(null);
      //const [skillLevels, setSLData] = useState(null)
      const navigate = useNavigate();
      const [skillLevels, loadingSL, slErr1, slErr2] = useGetSkillLevelsOData(`$filter=SkillPathid eq '${id}'&$orderby=indexNumber`, loadingSP);
      
      const HandleAddSkillPath = (newSkillPath:ISkillPath) => {
        if (skillPath!==null && newSkillPath.parentSkillPathId && skillPath.skillPathId===newSkillPath.parentSkillPathId) {
          skillPath.subSkillPaths?.push(newSkillPath);
          setSkillPath(skillPath);
          navigate(`/admin/editskillpath/${skillPath.skillPathId}/${newSkillPath.skillPathId}`);
        }
      }
      if (!skillPath || typeof(skillPath) === "boolean") {
        return (
        <>
          <AdminMenu />
          <h2>Edit Skill Path</h2>
          <Loading isLoading={true} />
        </>
        )
      }
        
      if (skillLevels === undefined || skillLevels===null || typeof(skillLevels) === "boolean"){
        return (
        <>
          <AdminMenu />
          <h2>Edit Skill Path</h2>
          <Loading isLoading={true} />
        </>)
      } 

    return(
      <>
        <AdminMenu />
        <EditSkillPathComponent id={id} parentid={parentid} skillPath={(skillPath)} skillLevels={(skillLevels)} addSkillPath={HandleAddSkillPath} />
      </>
      ) 
    };
  
  export default EditSkillPath;